import React from "react";
import Sparkline from "../Sparkline";

// Small "i" icon with a hover popup. Pure CSS (group-hover), no dependency.
// Clicks are stopped so cards that navigate on click don't fire when the icon
// is clicked.
export const InfoIcon = ({ text }) => 
  <span className="tw-relative tw-inline-block tw-group" onClick={(e) => e.stopPropagation()}>
    <span className="tw-ml-1 tw-inline-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-rounded-full tw-border tw-border-gray-400 tw-text-gray-500 tw-text-xs tw-leading-none tw-cursor-help tw-align-middle">i</span>
    <span className="tw-hidden group-hover:tw-block tw-absolute tw-z-50 tw-left-0 tw-top-5 tw-w-56 tw-px-2 tw-py-1.5 tw-rounded-md tw-bg-gray-900 tw-text-white tw-text-xs tw-leading-snug tw-shadow-lg tw-text-left tw-normal-case tw-font-normal">{text}</span>
  </span>
;

const DashboardCard = ({ title, subtitle, value, secondValue, color, disabled, onClick, sparklineData, sparklineColor, fullHeightValue, selected, info } ) => {
  const hasSparkline = sparklineData?.values?.length > 1;
  return (
    <>
      <div
        className={`${selected ? "tw-ring-2 tw-ring-primary tw-shadow-2xl tw--translate-y-1 tw-relative tw-z-10" : disabled ? "tw-shadow-sm" : "tw-shadow-xl"} tw-border tw-rounded-xl tw-pb-4 transition-transform ${onClick ? "tw-cursor-pointer hover:tw-border-primary" : ""}`}
        onClick={onClick}>
        <div
          className={`${color ? color : "tw-bg-primary"} ${disabled ? "tw-bg-opacity-50 " : ""} tw-w-full tw-p-2 tw-rounded-t-xl`}/>
        <div className={`${disabled ? "tw-bg-gray-400 tw-text-gray-500" : ""} tw-container ${fullHeightValue ? "tw-flex tw-flex-col" : ""}`}>
          <p className="tw-text-base tw-pt-2">
            {title ? title : null}{info ? <InfoIcon text={info} /> : null}
          </p>
          <p className="tw-hidden lg:tw-block tw-text-sm tw-pb-1 tw-text-gray-500">
            {subtitle ? subtitle : null}
          </p>
          <div className={`tw-flex tw-items-end tw-justify-between ${fullHeightValue ? "tw-flex-grow" : ""}`}>
            <div className={`${fullHeightValue ? "tw-w-full" : "tw-text-3xl"}`}>{value ? value : "---"}</div>
            {hasSparkline && <Sparkline data={sparklineData} color={sparklineColor || "#00acdc"} />}
          </div>
          {secondValue && <p className="tw-text-sm">{secondValue}</p>}
        </div>
      </div>
    </>
  );
};

export default DashboardCard;
